export default __webpack_public_path__ + "static/media/Snd3.cef04259.mp3";